import React, { useEffect, useState, useRef } from 'react';
import styles from './index.css';
import commentPic from '@src/mobile/details/layout/assets/commont.png';
import { Grounds } from '@ifeng-fe/client_grounds';
import { isIOS } from '@src/utils';
import { ListStore } from '@src/mobile/details/layout/store';
import { getCommentCount } from '@src/utils/base';
import { formatCommentCount } from '@src/utils/format';
import StickyFill from 'stickyfilljs';

const Comment = () => {
    const [commentCount, setCommentCount] = useState('');
    const useListStore = ListStore.useContainer();
    const { listStates, changeListStates } = useListStore;
    const { currentVideo, dramaSeries, statusBarHeight, videoAndStatusBarHeight, videoHeight } = listStates;
    const { commentUrl, thumbnails } = currentVideo;
    const briefRef = useRef();

    useEffect(() => {
        if (!('CSS' in window && CSS.supports && CSS.supports('position', 'sticky'))) {
            StickyFill.add(document.querySelectorAll('#introductionHeader'));
        }

        changeListStates({
            briefHeight: briefRef?.current?.offsetHeight || 0,
        });
    }, []);

    useEffect(
        () => {
            if (currentVideo) {
                getCount();
            }
        },
        [currentVideo],
    );

    // 获取评论数
    const getCount = async () => {
        const data = await getCommentCount([commentUrl]);
        const { count } = data[0] || { count: 0 };

        setCommentCount(formatCommentCount(count));
    };

    const handleShowComment = () => {
        // 端内评论
        if (window.grounds && window.grounds.redirect2Comments) {
            /*
                commentsUrl 评论地址
                title 分享标题
                shareUrl 分享地址
                thumbnail 图片数据（base64）
                documentId 文章id
                option 放置扩展参数
                top number 距webview顶部的距离。
                height nubmer 整个webview的高度。
            */
            Grounds.redirect2Comments(
                commentUrl, // commentsUrl：评论地址id
                currentVideo?.title, // title：标题
                '', // shareUrl：分享地址
                thumbnails?.image[0] || '', // thumbnail：缩略图
                commentUrl, // documentId：文章id
                {
                    height: parseFloat(window.innerHeight),
                    top: isIOS() ? videoAndStatusBarHeight + statusBarHeight : videoHeight,
                    doctype: 'web',
                    docurl: window.location.href,
                },
            );

            Grounds.pageStat({
                id: `video_${currentVideo.base62Id}`,
                type: 'phmovie_comment',
                ref: `phmovie_${dramaSeries.base62Id}`,
            });
        }
    };

    return (
        <div className={styles.introductionHeader} id="introductionHeader" ref={briefRef}>
            <div className={styles.introductionTitle}>简介</div>
            {window.grounds ? (
                <div className={styles.commentWrap} onClick={handleShowComment}>
                    <div className={styles.commentText}>点我发评论</div>

                    <div className={styles.commentIcon}>
                        <img src={commentPic} />
                        <div className={styles.commentNum}>{commentCount}</div>
                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default Comment;
